const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        wealthType: null,
        wealthCode: null,
        wealthName: null,
        wealthSecId: null,
    });
};

const initialState = setInitialState();

const wealthProduct = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.SET_WEALTH_PRODUCT:
            return state.merge({
                wealthType: action.data.wealthType,
                wealthCode: action.data.wealthCode,
                wealthName: action.data.wealthName,
                wealthSecId: action.data.wealthSecId,
            });
        case actionTypes.ERROR_WEALTH_PRODUCT:
            return state.merge({
                wealthType: null,
                wealthCode: null,
                wealthName: null,
                wealthSecId: null,
            });
        default:
            return state;
    }
};

module.exports = wealthProduct;
